import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import StickyCallBar from "./components/StickyCallBar";
import ServicePage from "./components/ServicePage";
import Home from "./pages/Home";
import Residential from "./pages/Residential";
import Commercial from "./pages/Commercial";
import EmergencyLocksmith from "./pages/EmergencyLocksmith";
import Partners from "./pages/Partners";
import Reviews from "./pages/Reviews";
import ServiceAreas from "./pages/ServiceAreas";
import ServiceAreaPage from "./components/ServiceAreaPage";
import Blog from "./pages/Blog";
import BlogPost from "./components/BlogPost";
import Pricing from "./pages/Pricing";
import Industries from "./pages/Industries";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Gallery from "./pages/Gallery";
import NotFound from "./pages/NotFound";
import { Toaster } from "./components/ui/sonner";

if ('scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual';
}

function ScrollToTop() {
  const { pathname } = useLocation();
  React.useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          {/* Residential */}
          <Route path="/residential" element={<Residential />} />
          <Route path="/residential/:slug" element={<ServicePage section="residential" />} />
          <Route path="/emergency-locksmith" element={<EmergencyLocksmith />} />
          {/* Commercial */}
          <Route path="/commercial" element={<Commercial />} />
          <Route path="/commercial/:slug" element={<ServicePage section="commercial" />} />
          {/* Other pages */}
          <Route path="/partners" element={<Partners />} />
          <Route path="/reviews" element={<Reviews />} />
          {/* Service areas — North Shore suburb pages */}
          <Route path="/service-areas" element={<ServiceAreas />} />
          <Route path="/service-areas/:slug" element={<ServiceAreaPage />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/industries" element={<Industries />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/projects" element={<Gallery />} />
          {/* Legacy redirects (plan §6.1) */}
          <Route path="/services" element={<Navigate to="/commercial" replace />} />
          <Route path="/gallery" element={<Navigate to="/projects" replace />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <Footer />
        <StickyCallBar />
        <Toaster position="top-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
